import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6">
        <div className="py-10 md:py-14">
          <div className="flex flex-col lg:flex-row items-start justify-between gap-8">
            <div className="max-w-sm">
              <Link to="/" className="inline-block">
                <span className="font-heading text-xl font-bold text-foreground-950 tracking-tight">
                  CSSBuy<span className="text-primary-500">Spreadsheet</span>
                </span>
              </Link>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                {t('heroSubtitle')}
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-8">
              <div>
                <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                  Navegação
                </h4>
                <ul className="space-y-2">
                  <li>
                    <Link
                      to="/"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors duration-200"
                    >
                      {t('navHome')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/guia-cssbuy-spreadsheet"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors duration-200"
                    >
                      {t('navGuide')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/#categories"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors duration-200"
                    >
                      {t('navCategories')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/#faq"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors duration-200"
                    >
                      {t('navFAQ')}
                    </Link>
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                  CSSBuy Spreadsheet
                </h4>
                <ul className="space-y-2">
                  <li>
                    <Link
                      to="/sobre-nos"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors duration-200"
                    >
                      {t('footerAbout')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/contato"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors duration-200"
                    >
                      {t('footerContact')}
                    </Link>
                  </li>
                  <li>
                    <a
                      href="https://kaspreadsheet.com"
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                    >
                      CSSBuy Sheet
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://kaspreadsheet.com"
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                    >
                      Buy It Now
                    </a>
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                  Legal
                </h4>
                <ul className="space-y-2">
                  <li>
                    <Link
                      to="/politica-privacidade"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors duration-200"
                    >
                      {t('footerPrivacy')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/termos"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors duration-200"
                    >
                      {t('footerTerms')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/disclaimer"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors duration-200"
                    >
                      {t('footerDisclaimer')}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {year} CSSBuySpreadsheet.asia. {t('footerRights')}
            </p>
            <p className="text-xs text-foreground-400">
              O melhor CSSBuy Spreadsheet para comunidade lusófona
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}